// src/routes/Admin.tsx
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Admin.scss";
import AdminDashboard from "../../components/Admin/AdminDashboard/AdminDashboard";

const Admin = () => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const stored = localStorage.getItem("admin-auth");
    if (stored === "true") {
      setIsAuthorized(true);
    }
  }, []);

  const handleLogin = () => {
    if (passwordInput === "barlindbeer2015") {
      localStorage.setItem("admin-auth", "true");
      setIsAuthorized(true);
    } else {
      alert("Wrong password!");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("admin-auth");
    setIsAuthorized(false);
    navigate("/");
  };

  if (!isAuthorized) {
    return (
      <div className="admin-login">
        <h2>Admin Login</h2>
        <input
          type="password"
          value={passwordInput}
          onChange={(e) => setPasswordInput(e.target.value)}
          placeholder="Enter password"
        />
        <button onClick={handleLogin}>Login</button>
      </div>
    );
  }

  return <AdminDashboard onLogout={handleLogout} />;
};

export default Admin;
